import React from 'react';
import ModelCard from '../ModelCard';
import { innerMoreType, modalType, modelTypeMap } from '../../../constants';
import ArrowIcon from '../../../assets/arrow.png';
import cs from 'classnames';
import { formatMenuState } from '../../base/modelLib/SideBar/utils';
import { applyModel } from '../../../helpers';
import { setModelsModalState } from '../../../store/state';
import { translate } from '@shakkerai/util-i18n';
import FlowCard from '../FlowCard';

const InnerMore = ({ data, cols, modelType, ratio, className, menus, setMenus, menuPath }) => {
  const { list, total, title, type } = data;
  if (total < 4 && type === innerMoreType.children) return null; // 合集没有total

  const getMore = () => {
    const { level } = menuPath;
    if (level === 0 && data.type === innerMoreType.children) {
      let target = null;
      let forceOpenId = null;
      menus.forEach((m1) => {
        (m1.children ?? []).forEach((c1) => {
          (c1.children ?? []).forEach((c2) => {
            if (c2.id === data.id) {
              target = c2;
              forceOpenId = m1.id;
            }
          });
        });
      });
      if (!target) return;
      const newMenus = formatMenuState(menus, target, forceOpenId);
      setMenus(newMenus);
    }
    if (data.type === innerMoreType.collect) {
      setModelsModalState({
        collectState: {
          data,
          menuPath,
        },
        keyword: '',
      });
      const newMenus = formatMenuState(
        menus,
        {}, // 清空菜单的选中状态
      );
      setMenus(newMenus);
    }
  };

  const _list = (list ?? []).slice(0, cols);
  if (!_list.length) return null;
  return (
    <div className={cs('w-full', className)}>
      <div className="flex justify-between pr-4 pb-4 ">
        <div className="text-[#2D2D2D] text-lg font-medium">{title}</div>
        {total > 7 && (
          <>
            <div className="flex items-center cursor-pointer" onClick={() => getMore()}>
              <span className="text-[#7A7A7A] text-sm">{translate('more')}</span>
              <img src={ArrowIcon} className={cs('w-[6px] h-[12px] pb-[2px] ml-[6px] text-[#000]')} />
            </div>
          </>
        )}
      </div>
      <div className="flex flex-wrap">
        {_list.map((item) => {
          return modelType === modalType.WORKFLOW ? (
            <FlowCard data={item} key={item.versionId} ratio={ratio} cols={cols} />
          ) : (
            <ModelCard
              data={item}
              key={item.versionId}
              ratio={ratio}
              cols={cols}
              showTag={true}
              query={''}
              onClick={applyModel}
            />
          );
        })}
      </div>
    </div>
  );
};

export default InnerMore;
